import React, { useState } from "react";
import { putApi } from "../pages/AppApis";
import CustomDatePickerComponent from "./CustomDatePickerComponent";
import SvgCross from "../assets/svg/SvgCross";
import { toast, ToastContainer } from "react-toastify";
import { showSuccessToast } from "../pages/utils";

export default function OpenHouseTimesModal({ property, onClose }) {
    let initialOpenhouseTimes = property?.open_house_times
        ? typeof property.open_house_times === "string"
            ? JSON.parse(property.open_house_times)
            : property.open_house_times
        : [];
    const [open, setOpen] = useState(false);
    const [toOpen, SettoOpen] = useState(false);
    const [open_Houses, setOpen_Houses] = useState(initialOpenhouseTimes);
    const [date, setDate] = useState(() => {
        const now = new Date();
        now.setHours(10, 0, 0, 0); // Default start time: 10 AM
        return now;
    });

    const [toDate, setToDate] = useState(() => {
        const futureDate = new Date(date); // Clone the `date` (from time)
        futureDate.setHours(futureDate.getHours() + 5); // Add 5 hours to the selected time
        return futureDate;
    });
    const onRemove = (index) => {
        const filteredTimesArray = open_Houses.filter((_, i) => i !== index);
        setOpen_Houses(filteredTimesArray);
        onAddMore(filteredTimesArray);
    };
    const onAddMore = async (timesArray) => {
        const formData = new FormData();
        formData.append("open_house_times", JSON.stringify(timesArray));
        const response = await putApi("/api/user/properties/" + property.property_id, formData, true);
        if (response) {
            showSuccessToast("Open house times updated successfully", {
                autoClose: 3000,
                pauseOnHover: false,
            });
        }
    };

    const onConfirm = () => {
        setOpen_Houses([...open_Houses, { from: date, to: toDate }]);
        onAddMore([...open_Houses, { from: date, to: toDate }]);
        setOpen(false);
        SettoOpen(false);
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { weekday: "short", month: "short", day: "numeric" };
        return date.toLocaleDateString("en-US", options);
    };
    // Helper function to format time to 12-hour format with AM/PM
    const formatTime = (dateString) => {
        const date = new Date(dateString);
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        const formattedHour = hours % 12 || 12; // Convert to 12-hour format
        return `${formattedHour}:${minutes} ${ampm}`;
    };
    return (
        <>
            <div
                onClick={onClose}
                className="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-screen tw-flex tw-items-center tw-justify-center tw-z-50 tw-bg-black tw-bg-opacity-50"
            >
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    className="tw-bg-white tw-p-10 tw-w-[40vw] tw-relative"
                >
                    <button onClick={() => onClose()} className="tw-absolute tw-top-2 tw-right-2">
                        <SvgCross />
                    </button>
                    {open_Houses?.map((item, index) => (
                        <div
                            key={index}
                            className="tw-wfull tw-relative tw-mb-5 tw-h-[89px] tw-border-[0.5px] tw-text-tertiary tw-border-tertiary tw-rounded-lg tw-flex tw-justify-center tw-items-center tw-flex-col tw-box-border"
                        >
                            <button onClick={() => onRemove(index)} className="tw-absolute tw-top-2 tw-right-2">
                                <SvgCross />
                            </button>
                            <span className="">{formatDate(item.from)}</span>
                            <span className="">
                                {formatTime(item.from)}- {formatTime(item.to)}
                            </span>
                        </div>
                    ))}
                    <button onClick={() => setOpen(true)} className="tw-bg-btn_secondary tw-w-full tw-text-center tw-py-2 tw-text-white">
                        Add More
                    </button>
                </div>
            </div>
            {open && (
                <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-items-center tw-justify-center tw-z-50">
                    <div className="tw-bg-white tw-p-4 md:tw-p-8 tw-rounded-lg tw-shadow-lg tw-z-50">
                        <h3 className="tw-text-xl tw-font-bold tw-mb-4">Select From Date and Time</h3>
                        <div className="tw-flex tw-gap-4">
                            <CustomDatePickerComponent selectedDate={date} setSelectedDate={setDate} />
                        </div>
                        <div className="tw-flex tw-justify-between tw-mt-4">
                            <button className="tw-bg-orange-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md" onClick={() => setOpen(false)}>
                                Cancel
                            </button>
                            <button
                                className="tw-bg-green-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md"
                                onClick={() => {
                                    setOpen(false);
                                    SettoOpen(true);
                                }}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {toOpen && (
                <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-items-center tw-justify-center tw-z-50">
                    <div className="tw-bg-white tw-p-4 md:tw-p-8 tw-rounded-lg tw-shadow-lg tw-z-50">
                        <h3 className="tw-text-xl tw-font-bold tw-mb-4">Select to Date and Time</h3>
                        <div className="tw-flex tw-gap-4">
                            <CustomDatePickerComponent selectedDate={toDate} setSelectedDate={setToDate} />
                        </div>
                        <div className="tw-flex tw-justify-between tw-mt-4">
                            <button className="tw-bg-orange-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md" onClick={() => SettoOpen(false)}>
                                Cancel
                            </button>
                            <button className="tw-bg-green-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md" onClick={() => onConfirm()}>
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
